<template>
  <div>
    <q-form
      ref="truckSettlement"
      class="waybill-form"
      :model="model"
      :rules="rules"
      label-width="120px"
    >
      <q-form-item
        label="سال"
        prop="year"
      >
        <q-input-number
          v-model="model.year"
        />
      </q-form-item>

      <q-form-item
        label="ماه"
        prop="month"
      >
        <q-input-number
          v-model="model.month"
        />
      </q-form-item>

      <q-form-item
        label="نفتکش"
        prop="truck"
      >
        <q-model-selector
          v-model="model.truck"
          plugin="gama"
          delegate="getTrucks"
          display-field="title"
          value-field="id"
          placeholder="نفتکش را انتخاب کنید"
          style="width: 100%"
        />
      </q-form-item>
      <q-form-item
        label="مبلغ اجاره تانکر"
        prop="tankerRentAmount"
      >
        <q-money v-model="model.tankerRent" />
      </q-form-item>
      <q-form-item
        label="دارسی (احمد این باشه؟)"
        prop="darsiAmount"
      >
        <q-money v-model="model.darsiAmount" />
      </q-form-item>
      <q-form-item
        prop="debtorTranslate"
      >
        <q-checkbox v-model="model.translateDebtor">
          <span>بدهکاری منتقل شود</span>
        </q-checkbox>
      </q-form-item>
      <q-form-item
        prop="creditorTranslate"
      >
        <q-checkbox v-model="model.translateCreditor">
          <span>بستانکاری منتقل شود</span>
        </q-checkbox>
      </q-form-item>
      <q-form-item
        prop="summerySettlement"
      >
        <q-checkbox v-model="model.justShowExpenseList">
          <span>خلاصه هزینه ها</span>
        </q-checkbox>
      </q-form-item>

      <q-form-item>
        <q-button
          type="primary"
          class="persist-button"
          @click="addSettlement"
        >
          <span>چاپ کن</span>
        </q-button>
      </q-form-item>
    </q-form>
  </div>
</template>

<script>

  import reportMixin from "../../../models/reportMixin";

  export default {
    name: "QGamaTruckSettlement",

    mixins: [reportMixin],
    props: {
      formStructure: {required: true, type: Object}
    },
    data() {
      return {
        model: {
          truck: undefined,
          year: 0,
          month: 0,
          tankerRent: 0,
          darsiAmount: 0,
          translateDebtor: false,
          translateCreditor: false,
          justShowExpenseList:false
        },
        rules: {
          year: [
            {required: true, message: 'حتما سال بازنامه را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1395, max: 1420, message: 'سال بین 1395 و 1420 وارد کنید', trigger: 'blur'}
          ],
          month: [
            {required: true, message: 'ماه مربوط به بارنامه را انتخاب کنید', trigger: 'blur'},
            {type: 'number', min: 1, max: 12, message: 'ماه باید بین 1 تا 12 باشد', trigger: 'blur'}
          ],
        }
      };
    },
    computed: {},
    mounted() {
    },
    methods: {
      addSettlement() {
        this.$refs['truckSettlement'].validate((valid) => {
          if (valid) {
            this.createReport({
              reportKey: 'truckSettlement',
              delegateData: this.model
            });
            this.readonly = true;
          } else {
            this.$notify({
              title: this.$qt('notify.exceptionTitle'),
              message: this.$qt('validation.completeFormMessage'),
              type: 'error'
            });
            return false;
          }
        });
      }
    },
  };
</script>

<style scoped>

  .persist-button:hover, .persist-button:focus {
    background-color: red;
  }

</style>
